import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Users } from "lucide-react";
import { useCurrency } from "@/contexts/CurrencyContext";

const ZemelapisStrip = () => {
  const { priceLabel } = useCurrency();
  return (
    <section className="bg-cream py-20 border-t border-ink/5">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mb-10">
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-ink/60">
            <MapPin className="h-4 w-4" />
            The Maps
          </span>
          <h2 className="font-marquee text-3xl md:text-4xl font-bold mt-3 leading-tight text-ink">
            One for you. One for the two of you.
          </h2>
          <p className="text-ink/70 text-base mt-3 leading-relaxed">
            Not tests, not horoscopes. These are documents written in your own words.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Solo */}
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-terracotta via-terracotta to-[#a04a32] text-cream p-8 md:p-10 shadow-[0_20px_60px_-20px_rgba(196,101,74,0.55)] flex flex-col">
            <div className="pointer-events-none absolute -top-16 -right-16 w-64 h-64 rounded-full bg-cream/10 blur-2xl" />
            <div className="relative flex flex-col h-full">
              <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-cream/80">
                <MapPin className="h-4 w-4" />
                SOLO Map · for you
              </span>
              <h3 className="font-marquee text-2xl md:text-3xl font-bold mt-4 leading-tight">
                A personal map about you
              </h3>
              <p className="text-cream/85 text-base mt-4 leading-relaxed">
                A portrait of who you are, what you long for and where you are heading. Fill in the
                questionnaire and get a document written in your own words.
              </p>
              <div className="mt-6 text-sm text-cream/75">For one person · {priceLabel("map_single")}</div>
              <div className="mt-auto pt-7 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/map/solo"
                  className="inline-flex items-center justify-center gap-2 bg-cream text-terracotta font-bold tracking-[0.12em] uppercase text-sm px-7 py-4 rounded-full hover:bg-white transition shadow-[0_8px_24px_-6px_rgba(0,0,0,0.25)]"
                >
                  Fill in the map
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>

          {/* Couples */}
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-ink via-ink to-[#2c2a26] text-cream p-8 md:p-10 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.45)] flex flex-col">
            <div className="pointer-events-none absolute -bottom-20 -left-10 w-72 h-72 rounded-full bg-[#f4c89a]/15 blur-3xl" />
            <div className="relative flex flex-col h-full">
              <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-semibold text-cream/80">
                <Users className="h-4 w-4" />
                Couples Map · for two
              </span>
              <h3 className="font-marquee text-2xl md:text-3xl font-bold mt-4 leading-tight">
                One map for the two of you
              </h3>
              <p className="text-cream/85 text-base mt-4 leading-relaxed">
                Each of you answers separately. Once you both finish, you get one shared document and
                four weeks of tasks.
              </p>
              <div className="mt-6 text-sm text-cream/75">For a couple · {priceLabel("couples_map")}</div>
              <div className="mt-auto pt-7 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/couples-map"
                  className="inline-flex items-center justify-center gap-2 bg-cream text-ink font-bold tracking-[0.12em] uppercase text-sm px-7 py-4 rounded-full hover:bg-white transition shadow-[0_8px_24px_-6px_rgba(0,0,0,0.25)]"
                >
                  Start together
                  <ArrowRight className="h-4 w-4" />
                </Link>
                <Link
                  to="/couples-map/code"
                  className="inline-flex items-center justify-center gap-2 border-2 border-cream/60 text-cream font-medium text-sm px-7 py-4 rounded-full hover:bg-cream/10 transition"
                >
                  I have a code
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZemelapisStrip;
